import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appDecimalInput]'
})
export class DecimalInputDirective {

  private regex: RegExp = /^\d*\.?\d{0,2}$/; // max 2 decimal places

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', '.', 
      ...Array.from({ length: 10 }, (_, i) => i.toString())
    ];

    const key = event.key;

    // Allow control/navigation keys
    if (allowedKeys.includes(key)) {
      // Prevent multiple dots
      if (key === '.' && (event.target as HTMLInputElement).value.includes('.')) {
        event.preventDefault();
      }
      return;
    }

    event.preventDefault(); // block all others
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const pastedInput: string = event.clipboardData?.getData('text') ?? '';
    const currentValue = (event.target as HTMLInputElement).value;
    const finalValue = currentValue + pastedInput;

    if (!this.regex.test(finalValue)) {
      event.preventDefault();
    }
  }
}
